import { tv, type VariantProps } from 'tailwind-variants'
import { Slot } from '@radix-ui/react-slot'

export const styles = tv({
	base: 'text-base leading-[1.4]',
	variants: {
		size: {
			small: 'text-sm leading-[19.6px]',
			default: 'text-base leading-[1.4]',
			large: 'text-lg leading-[23.5px]',
			xlarge: 'text-xl leading-[23.5px]',
		},
	},
})

interface ParagraphProps extends VariantProps<typeof styles> {
	className?: string
	asChild?: boolean
	children?: React.ReactNode
}

export const Paragraph = ({ className, size, asChild, children, ...rest }: ParagraphProps) => {
	const Comp = asChild ? Slot : 'p'
	return (
		<Comp {...rest} className={styles({ class: className, size })}>
			{children}
		</Comp>
	)
}
